<script>
    export let tab;
    export let selected;
</script>

<button class:selected={selected === tab} on:click={() => (selected = tab)}>
    <slot />
</button>

<style>
    button {
        background: none;
        border: none;
        border-bottom: 2px solid white;
        border-radius: 0;
        margin: 0;
        color: #ccc;
    }

    .selected {
        border-bottom: 2px solid teal;
        color: #333;
    }
</style>
